<template>
  <div class="content">
    <div class="contentPrincipal">
      <div class="myContent">
      <div class="tabContent">

        <div class="tabElement money active" @click="changeTab('money')">
          <span class="material-icons-sharp"> app_registration </span>Demande de
          transaction interne
        </div>
      </div>
</div>
      <div id="moneyTab" class="tabElementContent active">
        <!-- <div @click="addNewMoneyRequest" class="buttonAdd">
          <span> Faire une demande de retrait </span>
        </div> -->
        <div class="contentLists">
          <table class="contentListeTable">
            <thead>
              <tr>
                <th v-for="item in tableHeaderRequest" :key="item">
                  {{ item }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                @click="adminAceptRequestOutMoney(item)"
                :class="item.isSelected === true ? 'active' : 'noActive'"
                v-for="item in requestusertransactionData"
                :key="item._id"
              >
                <td>
                  {{ item.status === 'Acceptée' && item.files.length === 0 ? 'En attente de preuve' : (item.status === 'Acceptée' && item.files.length > 0 ? 'Terminé' : item.status) }}
                </td>
                <td>
                  {{ item.label }}
                </td>
                <td>
                  {{ item.amount }}
                </td>

                <td>
                  {{ item.observation }}
                </td>

                <!-- <td>
                  {{ item.requestTo ? item.requestTo.fullName : "" }}
                </td> -->
                <td>
                  {{
                    item.requestAcceptBy ? item.requestAcceptBy.fullName : ""
                  }}
                </td>
                <td>
                  {{ item.requestAcceptAt }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
        
        <script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "outMoney",
  components: {},
  data: () => ({
    tableHeader: [" ", "Nom ", "Poste", "Solde portefeuille"],
    tableHeaderRequest: [
      "Statut ",
      "Libellé de transaction",
      "Montant",
      "Observation",
      // "Demander a",
      "Acceptée par",
      "Acceptée le",

    ],
    isSelecteds: [],
    isSelectedAll: false,
  }),
  computed: {
    ...mapGetters([
      //   "contratData",
      //   "blData",
      //   "conteneurData",
      //   "contenuerAllData",
      //   "storeData",
      "userData",
      "requestusertransactionData",
    ]),
  },
  async mounted() {
    await this.getRequestUserTransaction({});
  },
  methods: {
    ...mapActions([
      //   "getContrat",
      //   "getSupplier",
      //   "getContratDetails",
      //   "getBl",
      //   "getConteneur",
      //   "getConteneurAll",
      //   "getTransitaire",
      //   "getStore",
      "getUser",
      "getRequestUserTransaction",
    ]),
    raccourcirTexte(texte) {
      return texte;
    },
    async addNewMoneyRequest() {
      
      this.$emit("show",true)
      const value = {
        modalType: "moneyRequest",
      };
      //   alert(item);
      this.$emit("editeRowForDash", {
        name: "moneyRequest",
        size: 300,
        value: value,
      });
      this.$emit("show",false)
    },
    adminAceptRequestOutMoney(item) {
      this.$emit("show",true)
      if (!item.isSelected) {
        for (let i = 0; i < this.requestusertransactionData.length; i++) {
          this.requestusertransactionData[i].isSelected = false;
        }
        item.isSelected = true;
        console.log("My value",this.requestusertransactionData);
        const value = {
          _id: item._id,
          modalType: "adminAceptRequestOutMoney",
          label: item.label,
          amount: item.amount,
          imageLink: item.files[0],
          observation: item.observation,
          status: item.status,
        };
        this.$emit("editeRowForDash", {
          name: "adminAceptRequestOutMoney",
          size: 300,
          value: value,
        });
      } else {
        item.isSelected = false;
        this.$emit("closeAllModal");
      }
      this.$emit("show",false)
      // Forcer la mise à jour de la vue après modification de isSelected
      this.$forceUpdate();
    },
    videMoneyToUser(item) {
      this.$emit("show",true)
      if (!item.isSelected) {
        for (let i = 0; i < this.requestusertransactionData.length; i++) {
          this.requestusertransactionData[i].isSelected = false;
        }
        item.isSelected = true;
        console.log(this.requestusertransactionData);
        const value = {
          _id: item._id,
          modalType: "videMoneyToUser",
          fullName: item.fullName,
          jobTitle: item.jobTitle,
          balance: item.wallet.balance,
        };
        this.$emit("editeRowForDash", {
          name: "videMoneyToUser",
          size: 300,
          value: value,
        });
      } else {
        item.isSelected = false;
        this.$emit("closeAllModal");
      }
      this.$emit("show",false)
      // Forcer la mise à jour de la vue après modification de isSelected
      this.$forceUpdate();
    },
    async changeTab(tabName) {
      this.$emit("show",true)
      this.$emit("closeAllModal");
      if (tabName === "contrat") {
        await this.getUser();
      } else if (tabName === "money") {
        await this.getRequestUserTransaction({});
      } else if (tabName === "conteneur") {
        await this.getConteneurAll({ alreadyInStock: "Oui" });
      } else if (tabName === "conteneurWait") {
        await this.getConteneurAll({ alreadyInStock: "Non" });
      }
      // Masquer tous les onglets
      var tabContents = document.querySelectorAll(".tabElementContent");
      tabContents.forEach(function (tabContent) {
        tabContent.classList.remove("active");
      });

      // Afficher l'onglet sélectionné
      var selectedTab = document.getElementById(tabName + "Tab");
      selectedTab.classList.add("active");

      // Mettre à jour l'état actif des onglets de la barre de navigation
      var tabElements = document.querySelectorAll(".tabElement");
      tabElements.forEach(function (tabElement) {
        tabElement.classList.remove("active");
      });

      var selectedTabElement = document.querySelector(".tabElement." + tabName);
      selectedTabElement.classList.add("active");
      this.$emit("show",false)
    },
  },
};
</script>
        